
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-13810.6 -15170.6 15.229 15.197"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_266_1","data-name":"Symbol 266 – 1","transform":"translate(-14213 -15261)"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Path_609","d":"M12.9 14.723v7.4a1.926 1.926 0 0 0 1.924 1.925h7.4a1.926 1.926 0 0 0 1.924-1.925v-7.4a1.926 1.926 0 0 0-1.925-1.923h-7.366a1.912 1.912 0 0 0-1.957 1.923z","data-name":"Path 609","transform":"translate(392.882 80.951)"}}),_c('path',{staticClass:"cls-1",attrs:{"id":"Path_611","d":"M4.614 12.749h-.92A1.189 1.189 0 0 1 2.5 11.554V4.192A1.7 1.7 0 0 1 4.192 2.5h7.394a1.189 1.189 0 0 1 1.194 1.195v1.45","data-name":"Path 611","transform":"translate(400.5 88.5)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3764","d":"M.6 3h4.933","data-name":"Path 3764","transform":"translate(408.47 96.762)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3765","d":"M.6 5.3h4.933","data-name":"Path 3765","transform":"translate(408.47 96.674)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3766","d":"M.6.6h4.933","data-name":"Path 3766","transform":"translate(408.47 96.854)"}})])])
          )
        }
      }
    